import { ArrowRight } from "lucide-react";
import { useTranslate } from "ra-core";
import { Link, useNavigate } from "react-router";
import { Button, buttonVariants } from "@/components/ui/button";

import type { Lead } from "../types";
import { useConvertLead } from "./useConvertLead";

/**
 * «В сделку» on a lead; once the lead has its deal, a link to that deal.
 * After the conversion the deal opens.
 */
export const ConvertButton = ({ lead }: { lead: Lead }) => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { mutate, isPending } = useConvertLead({
    onConverted: (dealId) => navigate(`/deals/${dealId}/show`),
  });

  if (lead.deal_id != null) {
    return (
      <Link
        to={`/deals/${lead.deal_id}/show`}
        className={buttonVariants({ variant: "outline" })}
      >
        {translate("crm.leads.open_deal")}
        <ArrowRight />
      </Link>
    );
  }
  return (
    <Button onClick={() => mutate(lead.id)} disabled={isPending}>
      {translate("crm.leads.convert")}
      <ArrowRight />
    </Button>
  );
};
